import src from "IMAGE";
export default { src, width: 667, height: 667, blurWidth: 0, blurHeight: 0};
